<template>
  <section class="A4 gaiyo">
    <div v-for="(page, index) in pages" :key="index"
      v-show="isPageVisible(index)"
      :id="page.id" :ref="page.ref"
      class="preview-pane"
      >
      <!--
      <div :ref="page.id"
        class="page-top" style="page-break-before: always;"></div>
      -->
      <div :ref="page.id"></div>
      <div class="page-top-space" v-show="index>0"><br></div>
      <div class="gaiyo-page-header">
        <span>横浜市建築局 情報相談課 {{ukeNo}}</span>
        <span style="display: table-cell;text-align: center;">{{userInfo.id}}</span>
        <span style="display: table-cell;text-align: center;">{{today}}</span>
        <span style="display: table-cell;text-align: right;">
          ページ {{index+1}}/{{pageCount}}
        </span>
      </div>
      <!--<br>-->
      <component :is="page.template" v-bind="page.props" v-if="isPageVisible(index)"></component>
      <div class="gaiyo-page-footer">
      </div>
    </div>
  </section>
</template>

<script>
import { dbglog, imgUrl, imgOldUrl } from '../common/utils'
import BrowseBuilding1men from '../components/BrowseBuilding1men.vue'
import BrowseBuilding2men from '../components/BrowseBuilding2men.vue'
import BrowseBuilding2men2 from '../components/BrowseBuilding2men-2.vue'
import BrowseBuildingShobun from '../components/BrowseBuildingShobun.vue'
import BrowseBuildingImage from '../components/building/BrowseBuildingImage.vue'

export default {
  data: () => {
    return {
      singlePage: true,
      currentPage: 0,
      pages: [],
      // 三面画像ImageViewer制御用
      scaleSize: 1,
      imageWidth: 0,  // オリジナル画像の幅
      imageHeight: 0, // オリジナル画像の高さ
      imgX: 0,        // ImageViewerのimg要素左位置
      imgY: 0,        // ImageViewerのimg要素上位置
      cursorX: 0,     // ImageViewer画像上のマウスカーソルX座標
      cursorY: 0,     // ImageViewer画像上のマウスカーソYX座標
      viewerRatio: 1, // 部分拡大窓の拡大率
      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
    }
  },
  components: {
    BrowseBuilding1men,
    BrowseBuilding2men,
    BrowseBuilding2men2,
    BrowseBuildingShobun,
    BrowseBuildingImage,
  },
  props: {
    gaiyo: {
      type: Object,
      default: null,
    },
    print: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.pages = [];
    if (this.gaiyo != null) {
      if (this.gaiyo.enableNendo && this.gaiyo.enableDb) {
        this.add1menPages();
        this.add2menPages();
      }
      dbglog(`BrowseBuild.mounted: add3menPages`);
      this.add3menPages();
      if (this.gaiyo.enableNendo && (this.gaiyo.enableDb || this.gaiyo.enableShobun)) {
        this.add4menPage();
      }
    }
    this.$store.commit('setGaiyoPages', this.pages);
    if (this.print) {
      setTimeout(() => {
        this.$store.commit('setPrinting', true);
        window.print();
        this.$store.commit('setPrinting', false);
        this.$router.back();
      });
    }
  },
  computed: {
    printing() {
      return this.$store.state.printing;
    },
    singlePrint() {
      return this.$store.state.singlePrint;
    },
    pageNo () {
      return this.$store.state.gaiyoPageNo;
    },
    pageCount () {
      return this.pages.length;
    },
    ukeNo () {
      //return this.$store.state.ukeNo;
      return this.gaiyo.ukeNo;
    },
    gaiyoId () {
      //return this.$store.state.gaiyoId;
      return this.gaiyo.daichoId;
    },
    today () {
      const dt = new Date();
      return `${dt.getFullYear()}/${dt.getMonth() + 1}/${dt.getDate()}`;
    },
    clientInfo () {
      return this.$store.state.clientInfo;
    },
    userInfo () {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    pageNo () {
      this.showPage(this.pageNo);
    }
  },
  methods: {
    isPageVisible(index) {
      return (this.currentPage==index
        || (!this.singlePrint && this.printing)
        || !this.singlePage);
    },
    /**
     * 概要書一面を1ページ登録する
     */
    addPage1(pageNo, first, last, props = null) {
      if (props === null) {
        props = {
          firstPart: first,
          lastPart: last,
        };
      }

      let pageName = `第一面(${pageNo})`;
      if (first == 0 && last == 7) {
        pageName = '第一面';
      }

      this.pages.push({
        id: `p1-${pageNo}`, ref: `#p1-${pageNo}`,
        name: pageName,
        template: 'browse-building-1men',
        props: props
      });
    },
    /**
     * 概要書一面のパートも分割して1ページ登録する
     */
    addPage1_div(pageNo, firstCategory, lastCategory, startPerson, endPerson, additionalLines) {
      dbglog(`addPage1_div(${pageNo},${firstCategory},${lastCategory},${startPerson},${endPerson},${additionalLines})`
      ,0);
      let props = {
        firstPart: firstCategory,
        lastPart: lastCategory,
        ownerStart: 0,
        ownerEnd: 99,
        sekkeiStart: 0,
        sekkeiEnd: 99,
        ikenStart: 0,
        ikenEnd: 99,
        kanriStart: 0,
        kanriEnd: 99,
        sekoStart: 0,
        sekoEnd: 99,
        useAdditional: additionalLines > 0,
        gaiyo: this.gaiyo,
      };

      switch (firstCategory) {
      case 1:
        props.ownerStart = startPerson;
        break;
      case 3:
        props.sekkeiStart = startPerson;
        break;
      case 4:
        props.ikenStart = startPerson;
        break;
      case 5:
        props.kanriStart = startPerson;
        break;
      case 6:
        props.sekoStart = startPerson;
        break;
      }

      switch (lastCategory) {
      case 1:
        props.ownerEnd = endPerson;
        break;
      case 3:
        props.sekkeiEnd = endPerson;
        break;
      case 4:
        props.ikenEnd = endPerson;
        break;
      case 5:
        props.kanriEnd = endPerson;
        break;
      case 6:
        props.sekoEnd = endPerson;
        break;
      }

      this.addPage1(pageNo, firstCategory, lastCategory, props);
    },
    /**
     * 概要書一面のページを登録する
     */
    add1menPages() {
      const pages = this.gaiyo.pages;
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        this.addPage1_div(page.pageNo, page.firstPart, page.lastPart, page.firstStartPerson, page.lastEndPerson, page.additionalSekkei);
      }
      return;
    },
    /**
     * 概要書二面のページを登録する
     */
    add2menPages() {
      /*
      const n1 = wordwrap(this.gaiyo.gaiyoRec.timeI_TIBAN,42).length;
      const n2 =  wordwrap(this.gaiyo.gaiyoRec.jukyO_DISP,42).length;
      const n3= wordwrap(this.gaiyo.gaiyoRec.etC_TIIKI, 40).length;
      const n4 = wordwrap(this.gaiyo.gaiyoRec.sitE_AREA_SUM_BIKO,44).length;
      const n5 = wordwrap(this.gaiyo.gaiyoRec.gutaI_SYUYO_YOTO,32).length;
      const additionalLineCount =
        (n1 > 0 ? n1 - 1 : 0) +
        (n2 > 0 ? n2 - 1 : 0) +
        (n3 > 0 ? n3 - 1 : 0) +
        (n4 > 0 ? n4 - 1 : 0) +
        (n5 > 0 ? n5 - 1 : 0);
      */
      let pageNo = 1;
      this.pages.push({
        id: `p2-${pageNo}`, ref: `#p2-${pageNo}`,
        name: `第二面(${pageNo})`,
        template: 'browse-building-2men',
        props: {
          nobemenVisible: false,
          //nobemenVisible: additionalLineCount < 5,
          gaiyo: this.gaiyo,
        }
      });

      pageNo = 2;
      this.pages.push({
        id: `p2-${pageNo}`, ref: `#p2-${pageNo}`,
        name: `第二面(${pageNo})`,
        template: 'browse-building-2men2',
        props: {
          nobemenVisible: true,
          //nobemenVisible: additionalLineCount >= 5,
          gaiyo: this.gaiyo,
        }
      });
    },
    /**
     * 概要書三面のページを登録する
     */
    add3menPages() {
      if (this.gaiyo == null || this.gaiyo.imageNames == null ||
        this.gaiyo.imageNames.length == 0) {
          return;
      }

      const existsDbPages = (this.pages.length > 0);

      for (let i = 0; i < this.gaiyo.imageNames.length; i++) {
        dbglog(`${i}:${this.gaiyo.imageNames[i]}`);
        const pageNo = i + 1;
        let pageTitle = existsDbPages ? '第三面' : '概要書';
        if (this.gaiyo.imageNames.length > 1) {
          pageTitle += `(${pageNo})`;
        }
        let url = existsDbPages ? imgUrl() : imgOldUrl();
        const fileName = this.gaiyo.imageNames[i];
        if (!url.endsWith('/') && fileName[0] != '/') {
          url += '/';
        }
        url += fileName;

        this.pages.push({
          id: `p3-${pageNo}`, ref: `#p3-${pageNo}`,
          name: pageTitle,
          template: 'browse-building-image',
          props: {
            ukeNo: this.gaiyo.ukeNo,
            fileName: fileName, //this.gaiyo.imageNames[i],
            fileUrl: url,
            pageNo: pageNo,
            //test
            scaleSize: this.scaleSize,
            canvasId: `canvas-${pageNo}`,
            gaiyo: this.gaiyo,
          }
        });
      }
    },
    /**
     * 概要書四面（処分の概要書）のページを登録する
     */
    add4menPage() {
      let chukanStart = 0;
      let chukanEnd = 0;
      try {
        chukanStart = this.gaiyo.chukan.length - 5;
        chukanEnd = this.gaiyo.chukan.length;
      }
      catch (err) {
        dbglog(`BrowseBuild.add4menPage(): ${err}`);
      }

      this.pages.push({
        id: 'p4', ref: '#p4', name: '処分の概要書',
        template: 'browse-building-shobun',
        props: {
          chukanStart: chukanStart,
          chukanEnd: chukanEnd,
          gaiyo: this.gaiyo,
        }
      });
    },
    /**
     * 概要書の指定ページを表示する
     */
    showPage (pageNo) {
      try {
        this.currentPage = pageNo;
        const id = this.pages[pageNo].id;
        this.scrollTo(id);
      }
      catch (err) {
        dbglog(`BrowseBld.showPage(${pageNo}): ${err}`, -1);
      }
    },
    /**
     * 概要書プレビュー画面を指定idまでスクロールする
     */
    scrollTo (id) {
      const el = this.$refs[id];
      dbglog(`scroll to ${el}:${id}`)
      if (el != null && el.length > 0) {
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/*
.A4 {
  width: 210mm;
  height: 296mm;
  //width: 190mm !important;
  //height: 276mm !important;
  //width: 172mm;
  //height: 251mm;
  page-break-after: auto;
  background: none;
}
*/
.gaiyo {
  //font-family: 游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN","Hiragino Mincho Pro",HGS明朝E,"MS Mincho";
  //font-weight: 600;
  //font-family: 游ゴシック, "ＭＳ ゴシック", "MS Gothic", "Yu Gothic", YuGothic;
    font-family: "ＭＳ 明朝","MS Mincho",游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN","Hiragino Mincho Pro",HGS明朝E;
  font-weight: 500;
  //width: 210mm;
  //height: 297mm;
}
.gaiyo-page-header {
  font-size: 8pt;
  /*
  position: relative;
  */
  display: table;
  width: 95%;
}
.preview-pane {
  width: 200mm !important;
  //height: 282mm !important;
  height: calc(296mm - 26mm);
  width: auto;
  //padding: 1em 2em;
  padding: 5mm 0 0 5mm;
}
.A4 {
  width: 190mm !important;
  //height: 276mm !important;
}
@media print {
  .gaiyo {
    font-family: "ＭＳ 明朝","MS Mincho",游明朝,"Yu Mincho",YuMincho,"Hiragino Mincho ProN","Hiragino Mincho Pro",HGS明朝E;
    font-weight: 500;
  }
  /*
  @page {
    margin-top: 0;
    margin-bottom: 0;
  }
  */
}

</style>